var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.tempId !== 4
        ? _c(
            "div",
            { staticClass: "banner-tabs" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.slotKeyChange },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                _vm._l(_vm.slotKeys, function (item) {
                  return _c("el-tab-pane", {
                    key: item,
                    attrs: { label: _vm.positionTitle(item), name: item },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.slotKeys, function (key) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentSlotKey === key,
                expression: "currentSlotKey === key",
              },
            ],
            key: key,
          },
          [
            _vm.isSimpleMode
              ? _c(
                  "div",
                  [
                    _c(
                      "el-form",
                      {
                        ref: key + "_bannerForm",
                        refInFor: true,
                        attrs: {
                          model: _vm.dataMap[key],
                          rules: _vm.rules,
                          "label-width": "120px",
                          size: "small",
                        },
                      },
                      [
                        _vm.tempId !== 4
                          ? _c(
                              "el-form-item",
                              {
                                attrs: { label: "默认banner", prop: "defAdId" },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _vm.dataMap[key].defImgUrl
                                      ? _c("div", [
                                          _c("img", {
                                            staticStyle: {
                                              width: "120px",
                                              height: "120px",
                                              "object-fit": "cover",
                                            },
                                            attrs: {
                                              src: _vm.dataMap[key].defImgUrl,
                                            },
                                          }),
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(_vm.dataMap[key].defName)
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "el-button",
                                      {
                                        staticStyle: { "margin-left": "20px" },
                                        attrs: { type: "primary" },
                                        on: {
                                          click: _vm.openDefaultBannerDialog,
                                        },
                                      },
                                      [_vm._v("选择/更换默认 banner")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _vm.loadingCache
                      ? _c("JumpTem", {
                          ref: key + "_JumpTem",
                          refInFor: true,
                          attrs: { value: _vm.dataMap[key], mark: key },
                          on: {
                            change: function (newVal) {
                              return _vm.$set(_vm.dataMap, key, newVal)
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "banner",
                                fn: function () {
                                  return [
                                    _c(
                                      "el-form",
                                      {
                                        ref: key + "_bannerForm",
                                        refInFor: true,
                                        attrs: {
                                          model: _vm.dataMap[key],
                                          rules: _vm.rules,
                                          "label-width": "120px",
                                          size: "small",
                                        },
                                      },
                                      [
                                        _vm.tempId !== 4
                                          ? _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "默认banner",
                                                  prop: "defAdId",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "align-items": "center",
                                                    },
                                                  },
                                                  [
                                                    _vm.dataMap[key].defImgUrl
                                                      ? _c("div", [
                                                          _c("img", {
                                                            staticStyle: {
                                                              width: "120px",
                                                              height: "120px",
                                                              "object-fit":
                                                                "cover",
                                                            },
                                                            attrs: {
                                                              src: _vm.dataMap[
                                                                key
                                                              ].defImgUrl,
                                                            },
                                                          }),
                                                          _c("div", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.dataMap[key]
                                                                  .defName
                                                              )
                                                            ),
                                                          ]),
                                                        ])
                                                      : _vm._e(),
                                                    _c(
                                                      "el-button",
                                                      {
                                                        staticStyle: {
                                                          "margin-left": "20px",
                                                        },
                                                        attrs: {
                                                          type: "primary",
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.openDefaultBannerDialog,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "选择/更换默认 banner"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "form-tip",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 配置 banner 前需选择备用默认 banner "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "banner名称",
                                              prop: "name",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              directives: [
                                                {
                                                  name: "no-emoji",
                                                  rawName: "v-no-emoji",
                                                },
                                              ],
                                              staticStyle: { width: "400px" },
                                              attrs: {
                                                placeholder: "请输入banner名称",
                                                maxlength: "30",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value: _vm.dataMap[key].name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataMap[key],
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression: "dataMap[key].name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "权重",
                                              prop: "sort",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                _c("el-input-number", {
                                                  attrs: { min: 1, max: 10 },
                                                  model: {
                                                    value:
                                                      _vm.dataMap[key].sort,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.dataMap[key],
                                                        "sort",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dataMap[key].sort",
                                                  },
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form-tip",
                                                    staticStyle: {
                                                      width: "450px",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  （权重数值越小越靠前，banner优先级越高）\n                "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "展示时间",
                                              required: "",
                                              prop: "startTime",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "400px" },
                                              attrs: {
                                                type: "datetimerange",
                                                "range-separator": "至",
                                                "start-placeholder":
                                                  "选择开始日期",
                                                "end-placeholder":
                                                  "选择结束日期",
                                                format: "yyyy-MM-dd HH:mm:ss",
                                                "value-format":
                                                  "yyyy-MM-dd HH:mm:ss",
                                                "picker-options":
                                                  _vm.pickerOptionStart(),
                                                "default-time": [
                                                  "00:00:00",
                                                  "23:59:59",
                                                ],
                                              },
                                              on: {
                                                change: function (val) {
                                                  return _vm.handleDateRangeChange(
                                                    val,
                                                    key
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.dataMap[key].dateRange,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dataMap[key],
                                                    "dateRange",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dataMap[key].dateRange",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "展示地区",
                                              prop:
                                                _vm.dataMap[key].allArea === 1
                                                  ? "allArea"
                                                  : "areaIdList",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    model: {
                                                      value:
                                                        _vm.dataMap[key]
                                                          .allArea,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.dataMap[key],
                                                          "allArea",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "dataMap[key].allArea",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: 1 } },
                                                      [_vm._v("全部地区")]
                                                    ),
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: 0 } },
                                                      [_vm._v("部分地区")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm.dataMap[key].allArea !== 1
                                              ? _c("YdCitySelect", {
                                                  attrs: {
                                                    mode: "2",
                                                    placeholder: "请选择地区",
                                                    customHttp:
                                                      _vm.getDriverAreaTree,
                                                    fieldFormat:
                                                      _vm.fieldFormat,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dataMap[key]
                                                        .areaIdList,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.dataMap[key],
                                                        "areaIdList",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dataMap[key].areaIdList",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _vm.tempId === 1
                                          ? _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "标题文字图",
                                                  prop: "marketImgUrl",
                                                },
                                              },
                                              [
                                                _c("imageUpload", {
                                                  attrs: {
                                                    imageList: _vm.dataMap[key]
                                                      .marketImgUrl
                                                      ? [
                                                          {
                                                            url: _vm.dataMap[
                                                              key
                                                            ].marketImgUrl,
                                                          },
                                                        ]
                                                      : [],
                                                    limit: 1,
                                                    fileSize: 1,
                                                    isShowTip: true,
                                                    WHtip: true,
                                                    width: 150,
                                                    height: 36,
                                                    fileType: ["png", "jpg"],
                                                    accept: ".jpg,.png",
                                                    multiple: false,
                                                    code: "banner",
                                                  },
                                                  on: {
                                                    input: function (val) {
                                                      return _vm.getImg(
                                                        val,
                                                        "marketImgUrl",
                                                        key
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "banner图",
                                              prop: "imgUrl",
                                            },
                                          },
                                          [
                                            _c("imageUpload", {
                                              attrs: {
                                                imageList: _vm.dataMap[key]
                                                  .imgUrl
                                                  ? [
                                                      {
                                                        url: _vm.dataMap[key]
                                                          .imgUrl,
                                                      },
                                                    ]
                                                  : [],
                                                limit: 1,
                                                fileSize: 1,
                                                isShowTip: true,
                                                WHtip: true,
                                                width: _vm.width,
                                                height: _vm.height,
                                                fileType: ["png", "jpg"],
                                                accept: ".jpg,.png",
                                                multiple: false,
                                                code: "banner",
                                              },
                                              on: {
                                                input: function (val) {
                                                  return _vm.getImg(
                                                    val,
                                                    "imgUrl",
                                                    key
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm.tempId === 1
                                          ? _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "营销文案",
                                                  prop: "marketText",
                                                },
                                              },
                                              [
                                                _c("el-input", {
                                                  directives: [
                                                    {
                                                      name: "no-emoji",
                                                      rawName: "v-no-emoji",
                                                    },
                                                  ],
                                                  staticStyle: {
                                                    width: "400px",
                                                  },
                                                  attrs: {
                                                    rows: 4,
                                                    placeholder: "请输入",
                                                    maxlength: "6",
                                                    "show-word-limit": "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dataMap[key]
                                                        .marketText,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.dataMap[key],
                                                        "marketText",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "dataMap[key].marketText",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
          ]
        )
      }),
      _c("DefaultBannerDialog", {
        attrs: {
          visible: _vm.defaultBannerDialogVisible,
          value:
            _vm.currentSlotKey && _vm.dataMap[_vm.currentSlotKey]
              ? _vm.dataMap[_vm.currentSlotKey].defaultBanner
              : null,
          slotKey: _vm.activeTab,
        },
        on: {
          "update:visible": function ($event) {
            _vm.defaultBannerDialogVisible = $event
          },
          confirm: _vm.handleDefaultBannerConfirm,
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }